import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const RichLogsExportDropdownStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "rich-logs-export-dropdown",
  },
)`
  display: flex;
  align-items: center;

  .rich-logs-export-button {
    display: inline-flex;
    align-items: center;
    gap: 2px;
  }

  .rich-logs-export-chevron {
    width: 20px;
    height: 20px;
    margin-inline-start: -2px;
  }

  .rich-logs-export-csv-hidden {
    display: none;
  }

  .rich-logs-export-popper {
    z-index: ${ScreenDepth.DROPDOWN_MENU};
  }
`;
